import { Link } from "react-router-dom";
import { Instagram, Linkedin, MapPin, Mail, Phone } from "lucide-react";
import { useT } from "@/lib/i18n";

export default function Footer() {
  const { t } = useT();
  return (
    <footer className="relative dark-section border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <img src="/asirox-logo.png" alt="Asirox" className="logo-white h-10 w-auto"/>
          <p className="mt-6 text-white/70 max-w-md leading-relaxed">{t("footer.tagline")}</p>
          <div className="flex gap-4 mt-8">
            <a href="https://instagram.com/asiroxofficial" target="_blank" rel="noreferrer" className="p-2 border border-white/15 hover:border-white hover:text-white transition" data-testid="footer-instagram"><Instagram size={18} strokeWidth={1.5}/></a>
            <a href="https://linkedin.com/company/asiroxl" target="_blank" rel="noreferrer" className="p-2 border border-white/15 hover:border-white hover:text-white transition" data-testid="footer-linkedin"><Linkedin size={18} strokeWidth={1.5}/></a>
          </div>
        </div>

        <div className="md:col-span-3">
          <p className="overline mb-5">{t("footer.catalog")}</p>
          <ul className="space-y-3 text-white/80 text-sm">
            <li><Link to="/equipos-dermo-faciales/vega-pro" className="link-underline">Asirox VEGA Pro</Link></li>
            <li><Link to="/equipos-dermo-faciales/nova-triwave" className="link-underline">Asirox NOVA Triwave</Link></li>
            <li><Link to="/equipos-dermo-faciales/axis-med" className="link-underline">Asirox AXIS Med</Link></li>
            <li><Link to="/equipos-dermo-faciales/preime-dermafacial" className="link-underline">Préime DermaFacial</Link></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <p className="overline mb-5">{t("footer.company")}</p>
          <ul className="space-y-3 text-white/80 text-sm">
            <li><Link to="/tecnologia-dermo-facial" className="link-underline">{t("nav.technology")}</Link></li>
            <li><Link to="/sectores-aparatologia-estetica" className="link-underline">{t("nav.sectors")}</Link></li>
            <li><Link to="/casos-de-exito-dermo-facial" className="link-underline">{t("nav.cases")}</Link></li>
            <li><Link to="/blog-dermo-facial" className="link-underline">{t("nav.blog")}</Link></li>
            <li><Link to="/asesor-dermo-facial-ia" className="link-underline">{t("nav.assistant")}</Link></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <p className="overline mb-5">{t("footer.contact")}</p>
          <ul className="space-y-3 text-white/80 text-sm">
            <li className="flex gap-2 items-start"><MapPin size={14} strokeWidth={1.5} className="mt-1 text-white shrink-0"/><span>Calle Rocafort 89,<br/>08205 Sabadell,<br/>Barcelona, España</span></li>
            <li className="flex gap-2 items-center"><Phone size={14} strokeWidth={1.5} className="text-white"/><a href="tel:+34935704954" className="link-underline">+34 935 70 49 54</a></li>
            <li className="flex gap-2 items-center"><Mail size={14} strokeWidth={1.5} className="text-white"/><a href="mailto:info@asirox.com" className="link-underline">info@asirox.com</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row justify-between gap-3 text-xs text-white/50">
          <p>© {new Date().getFullYear()} Asirox · {t("footer.copyright")}</p>
          <p className="font-mono">CE IIb · FDA 510(k) · ISO 13485</p>
        </div>
      </div>
    </footer>
  );
}
